import { useState } from "react";
import { getUser } from "@/lib/auth";
import InstitutionAuth from "@/pages/institution/InstitutionAuth";
import InstitutionDashboard from "@/pages/institution/InstitutionDashboard";

export default function InstitutionPage() {
  const [user, setUser] = useState(getUser());
  const isInstitution = user?.role === "institution";

  return isInstitution
    ? <InstitutionDashboard onLogout={() => setUser(null)} />
    : <InstitutionAuth onSuccess={(u) => setUser(u)} />;
}
